import { useMemo } from 'react';
import { getConceptChartOptions, getChainChartOptions } from '../constants/chartOptions';

export const useChartOptions = (votesConcept, chainConcept) => {
    const conceptChartOptions = useMemo(() =>
        getConceptChartOptions(votesConcept),
        [votesConcept]
    );

    const chainChartOptions = useMemo(() =>
        getChainChartOptions(chainConcept),
        [chainConcept]
    );

    return {
        conceptChartOptions,
        chainChartOptions
    };
};